export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M8 .5c-.662 0-1.77.249-2.813.525a61.11 61.11 0 00-2.772.815 1.454 1.454 0 00-1.003 1.184c-.573 4.197.756 7.307 2.368 9.365a11.192 11.192 0 002.417 2.3c.371.256.715.451 1.007.586.27.124.558.225.796.225s.527-.101.796-.225c.292-.135.636-.33 1.007-.586a11.191 11.191 0 002.418-2.3c1.611-2.058 2.94-5.168 2.367-9.365a1.454 1.454 0 00-1.003-1.184 61.09 61.09 0 00-2.772-.815C9.77.749 8.663.5 8 .5zM8 4a.905.905 0 00-.9.995l.35 3.507a.553.553 0 001.1 0l.35-3.507A.905.905 0 008 4zm.002 6a1 1 0 100 2 1 1 0 000-2z\"/>",
  "attrs": {
    "width": "1em",
    "height": "1em",
    "viewBox": "0 0 16 16",
    "class": "bi bi-shield-fill-exclamation",
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};